"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ApiKey", {
    enumerable: true,
    get: function() {
        return ApiKey;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const ApiKey = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    last_used_at: _zod.z.date().or(_zod.z.null()),
    deleted_at: _zod.z.date().or(_zod.z.null()),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    user_id: _zod.z.instanceof(_bson.ObjectId),
    api_token_id: _zod.z.string(),
    api_key: _zod.z.string().optional(),
    enabled: _zod.z.boolean().optional()
});
